import React, { useEffect, useState } from 'react';
import { PageProps } from '../types/auth';
import styles from './styles/Home.module.css';

interface VisitedPage {
  name: string;
  url: string;
  count?: number;
}

const HomePage: React.FC<PageProps> = ({ user }) => {
  const [gistContent, setGistContent] = useState<string>('');
  const recentPages = JSON.parse(localStorage.getItem('recentPages') || '[]') as VisitedPage[];
  const frequentPages = JSON.parse(localStorage.getItem('frequentPages') || '[]') as VisitedPage[];

  useEffect(() => {
    const fetchGistContent = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_MOTD_GIST_URL + `?ts=${Date.now()}` || '');

        if (!response.ok) {
          console.error('Failed to fetch gist content');
          return;
        }
        const html = await response.text();
        console.log('Fetched content:', html);
        setGistContent(html);
      } catch (error) {
        console.error('Error fetching gist content:', error);
      }
    };

    fetchGistContent();
  }, []);

  // Return blank page for members
  const selectedOrgRole = user?.organizations?.find(org => org.org_id === Number(localStorage.getItem('selectedOrgID')))?.role;
  if (selectedOrgRole === 'member') {
    return <div></div>;
  }

  return (
    <div className={styles.container}>
      {gistContent && (
        <div className={styles.motdSection} dangerouslySetInnerHTML={{ __html: gistContent }} />
      )}

      {recentPages.length > 0 && (
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Recently visited</h2>
          <ul className={styles.list}>
            {recentPages.map((page, index) => (
              <li key={index} className={styles.listItem}>
                <a href={page.url} className={styles.link}>{page.name}</a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {frequentPages.length > 0 && (
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Frequently visited</h2>
          <ul className={styles.list}>
            {frequentPages.map((page, index) => (
              <li key={index} className={styles.listItem}>
                <a href={page.url} className={styles.link}>{page.name}</a>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Sitemap</h2>
        <ul className={styles.sitemap}>
          <li className={styles.sitemapItem}>
            <a href="/members" className={styles.sitemapLink}>Members</a>
            <ul className={styles.sitemapSublist}>
              <li className={styles.listItem}>
                <a href="/invites" className={styles.link}>Invites</a>
              </li>
            </ul>
          <li className={styles.listItem}>
            <a href="/groups" className={styles.link}>Groups</a>
          </li>
          </li>
          <li className={styles.sitemapItem}>
            <a href="/curriculums" className={styles.sitemapLink}>Curriculums</a>
            <ul className={styles.sitemapSublist}>
              <li className={styles.listItem}>
                <a href="/skills" className={styles.link}>Skills</a>
              </li>
              <li className={styles.listItem}>
                <a href="/accomplishments" className={styles.link}>Accomplishments</a>
              </li>
            </ul>
          </li>
          <li className={styles.listItem}>
            <a href="/snippets" className={styles.link}>Snippets</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HomePage; 